module.exports = __webpack_public_path__ + "images/category_lp/car/assessment_achievements/5@2x_48a00e45cc6c5884a11f1ab1828b8f85.png";